import React, { useEffect, useRef } from 'react';
import PublicProfile from './PublicProfile';
import ManagePlan from './ManagePlan';
import ClayProfile from './ClayProfile';
import { useAuthContext } from '@support/hooks/use-auth-context';
import CancelPlan from './CancelPlan';
import SwitchPlan from './SwitchPlan';

export default function ProfileSettingsPanel() {
  const authCtx = useAuthContext();
  const user = useRef(authCtx.user);

  useEffect(() => {
    if (authCtx.user) {
      user.current = authCtx.user;
    }
  });

  return (
    <>
      {!!user.current?.contact_id && <ClayProfile contactID={String(user.current?.contact_id)} />}
      <PublicProfile />
      <ManagePlan />
      <SwitchPlan />
      <CancelPlan />
    </>
  );
}
